import { callPost } from '../graphql';
import { GET_ACCOUNT } from '../graphql/query';

export const getAccount = async (token?: string) => {
    const { data: axiosData } = await callPost(GET_ACCOUNT, {}, token);
    const { data } = axiosData;
    return data.bagyPayVindiGetAccount;
};
